import { useEffect } from 'react';

// On a phone every `.data-table` (and any table marked `.m-cards`) renders
// as a stack of cards — one card per row, "COLUMN  value" lines inside (see
// mobile.css). That needs each cell to know its column name, so this watches
// the page and copies the header text onto every body cell as data-label.
// One mount covers all ~55 tables in the app; nothing per page. A table
// that must stay a grid on the phone opts out with `.keep-table`.
const SELECTOR = 'table.data-table:not(.keep-table), table.m-cards:not(.keep-table)';

function labelTable(table) {
  const headRow = table.tHead && table.tHead.rows[table.tHead.rows.length - 1];
  if (!headRow) return;
  // Expand header colspans so cell N lines up with column N.
  const labels = [];
  for (const th of headRow.cells) {
    const text = (th.innerText || th.textContent || '').replace(/[▲▼↑↓⇅]/g, '').replace(/\s+/g, ' ').trim();
    for (let i = 0; i < (th.colSpan || 1); i++) labels.push(text);
  }
  for (const body of table.tBodies) {
    for (const row of body.rows) {
      let col = 0;
      for (const td of row.cells) {
        const label = td.colSpan > 1 ? '' : (labels[col] || '');
        if (td.getAttribute('data-label') !== label) td.setAttribute('data-label', label);
        col += td.colSpan || 1;
      }
    }
  }
}

export default function useMobileTableLabels(enabled) {
  useEffect(() => {
    if (!enabled || typeof MutationObserver === 'undefined') return undefined;
    let frame = 0;
    const run = () => {
      frame = 0;
      document.querySelectorAll(SELECTOR).forEach(labelTable);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(run); };
    run();
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    return () => {
      observer.disconnect();
      if (frame) cancelAnimationFrame(frame);
    };
  }, [enabled]);
}
